export default __webpack_public_path__ + "static/car-4e9824ec45712d3e1b6d4fe52663026c.png";